var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulationMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F8F2FF",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 32,
    height: 40,
    rx: 4,
    fill: "#996CFE",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 24,
    height: 28,
    rx: 2,
    fill: "#996CFE",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 56,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#996CFE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#996CFE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#996CFE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 36,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#996CFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#996CFE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 44,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#996CFE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#996CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationMode);
export default __webpack_public_path__ + "static/media/simulation-mode.17809a3a9730232bc1925cb661cb5d0f.svg";
export { ForwardRef as ReactComponent };